export function parseApiErrorResponse(data) {
  if (data == null || data === "") {
    return null;
  }
  if (typeof data === "object") {
    return data;
  }
  if (typeof data === "string") {
    try {
      return JSON.parse(data);
    } catch {
      return { Message: data };
    }
  }
  return null;
}

export function getApiErrorMessage(errorOrPayload) {
  if (!errorOrPayload) {
    return null;
  }

  const fromAxios = errorOrPayload.response
    ? parseApiErrorResponse(errorOrPayload.response.data)
    : null;
  const parsed = fromAxios || parseApiErrorResponse(errorOrPayload);

  if (!parsed) {
    return errorOrPayload.message || null;
  }

  return (
    parsed.Message
    || parsed.message
    || parsed.responseDescription
    || parsed.ResponseDescription
    || parsed.Details
    || parsed.details
    || null
  );
}

export function getApiErrorDetails(errorOrPayload) {
  if (!errorOrPayload) {
    return { code: "", message: "", details: "", correlationId: "" };
  }

  const fromAxios = errorOrPayload.response
    ? parseApiErrorResponse(errorOrPayload.response.data)
    : null;
  const parsed = fromAxios || parseApiErrorResponse(errorOrPayload);

  if (!parsed) {
    return {
      code: errorOrPayload.code || "",
      message: errorOrPayload.message || "",
      details: "",
      correlationId: "",
    };
  }

  return {
    code: parsed.Code || parsed.code || parsed.responseCode || parsed.ResponseCode || "",
    message: parsed.Message || parsed.message || parsed.responseDescription || parsed.ResponseDescription || parsed.Details || parsed.details || "",
    details: parsed.Details || parsed.details || parsed.responseDescription || parsed.ResponseDescription || "",
    correlationId: parsed.CorrelationId || parsed.correlationId || "",
  };
}

/** Plain serializable payload for Redux (avoids storing Axios error objects). */
export function toPlainApiError(errorOrPayload) {
  const details = getApiErrorDetails(errorOrPayload);
  const parsed = errorOrPayload?.response
    ? parseApiErrorResponse(errorOrPayload.response.data)
    : parseApiErrorResponse(errorOrPayload);

  return {
    Code: details.code,
    Message: details.message || errorOrPayload?.message || "Unexpected error",
    Details: details.details || details.message || "",
    CorrelationId: details.correlationId,
    validationResults: parsed?.validationResults || parsed?.ValidationResults || [],
  };
}

export function isCheckBinErrorResponse(response) {
  if (response == null || typeof response !== "object") {
    return true;
  }
  if (response.responseCode === "B0000") {
    return false;
  }
  if (response.responseCode && response.responseCode !== "B0000") {
    return true;
  }
  // Gateway fault contract (e.g. Code: "RVV0000999999")
  if (response.Code || response.Message || response.code || response.message || response.validationResults?.length) {
    return true;
  }
  return false;
}

export function isInstallmentErrorResponse(response) {
  if (response == null || typeof response !== "object" || Array.isArray(response)) {
    return true;
  }
  if (response.responseCode === "B0000") {
    return false;
  }
  if (response.responseCode && response.responseCode !== "B0000") {
    return true;
  }
  if (response.Code || response.Message || response.code || response.message || response.validationResults?.length) {
    return true;
  }
  return false;
}
